import { API } from '../bb/bbShared';

export const PI_CODE_KEY = 'capex_pi_code';

export const piFetch = async (token, path, opts = {}) => {
  const res = await fetch(`${API}/api${path}`, {
    ...opts,
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json', 'X-PI-Code': sessionStorage.getItem(PI_CODE_KEY) || '', ...(opts.headers || {}) },
  });
  if (res.status === 423) { sessionStorage.removeItem(PI_CODE_KEY); window.dispatchEvent(new Event('pi-locked')); }
  if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.detail || 'Erreur'); }
  return opts.raw ? res : res.json();
};

export const STATUT_POINT = { brouillon: ['Brouillon', '#FBEFD5', '#7A4F0E'], valide: ['Validé', '#E3F1E6', '#1F6B35'], archive: ['Archivé', '#E7E5E1', '#57534E'] };
export const ACTION_STATUTS = { a_faire: 'À faire', en_cours: 'En cours', terminee: 'Terminée', bloquee: 'Bloquée' };
export const DECL_LABELS = {
  contrats_n_nouveaux: ['Contrats signés N · nouveaux', 'annee'],
  contrats_n_renouvellements: ['Contrats signés N · renouvellements', 'annee'],
  contrats_m1_nouveaux: ['Contrats M-1 · nouveaux', 'mois_m1'],
  contrats_m1_renouvellements: ['Contrats M-1 · renouvellements', 'mois_m1'],
  projection_m_new_business: ['Projection signatures M · New Business', 'mois_courant'],
  projection_m_renouvellements: ['Projection signatures M · Renouvellement', 'mois_courant'],
  rdv_s1: ['RDV réalisés S-1', 'semaine_s1'],
  rdv_s_prevus: ['RDV prévus S', 'semaine_s'],
};
const MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
export const periodLabel = (kind, per) => {
  if (!per) return '';
  if (kind === 'annee') return `Du 1er janvier ${per.annee} à la date du point`;
  if (kind === 'mois_m1' || kind === 'mois_courant') { const [m, y] = per[kind].split('/'); return `${MOIS[Number(m) - 1]} ${y}`; }
  const s = new Date(`${per[kind]}T12:00:00`); const e = new Date(s); e.setDate(e.getDate() + 6);
  return `Semaine du ${s.getDate()} ${MOIS[s.getMonth()]} au ${e.getDate()} ${MOIS[e.getMonth()]} ${e.getFullYear()}`;
};
